module.exports = __webpack_public_path__ + "static/media/popupX.aed904da.svg";